import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import MaterialTable from "material-table";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import TrashIcon from "@material-ui/icons/Delete";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import moment from "moment";

import * as actions from "./redux/actions";
import AskAlert from "../common/AskAlert";
import {
  SERVER_PATH,
  AXIOS_CONFIG,
  ROLE_VIEWER,
  STATUS_PROJECT_PUBLISHED,
} from "../common/redux/constantes";
import SelectDeliverable from "./SelectDeliverable";
import CostModel from "./CostModel";
import ReviewCostModel from "./ReviewCostModel";

export class ListControlAccount extends Component {
  static propTypes = {
    ca: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    anchorEl: undefined,
    accountMenu: undefined,
    cas: [],
    openDeleteAlert: false,
    deleteCaID: -1,
    deleteAssignationID: -1,
    caSelected: null,
    openSelectDeliverable: false,
  };

  constructor(props) {
    super(props);
    this.tableRef = React.createRef();

    //binding
    this.closeSelectDeliverable = this.closeSelectDeliverable.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
  }

  deleteItem() {
    if (this.state.deleteCaID !== -1) {
      this.deleteCa();
    } else if (this.state.deleteAssignationID !== -1) {
      this.deleteAssignation();
    }
  }

  deleteCa = () => {
    if (this.state.deleteCaID !== -1) {
      this.props.actions.deleteCa(this.tableRef, this.state.deleteCaID);
      this.cancelDelete();
    }
  };

  deleteAssignation = () => {
    if (this.state.deleteAssignationID !== -1) {
      this.props.actions.deleteAssignation(
        this.tableRef,
        this.state.deleteAssignationID
      );
      this.cancelDelete();
    }
  };

  cancelDelete = () => {
    this.setState({ openDeleteAlert: false });
  };

  askDeleteCa = (caID) => {
    this.setState({ deleteAssignationID: -1, deleteCaID: -1 });
    this.setState({
      openDeleteAlert: true,
      deleteCaID: caID,
      dialogTitle: "Delete Control Account",
      dialogContent: "Are you sure to delete this control account?",
    });
  };

  askDeleteAssignation = (assignationID) => {
    this.setState({ deleteAssignationID: -1, deleteCaID: -1 });
    this.setState({
      openDeleteAlert: true,
      deleteAssignationID: assignationID,
      dialogTitle: "Unassign deliverable",
      dialogContent: "Are you sure to delete this relation?",
    });
  };

  refreshTable = () => {
    this.tableRef.current && this.tableRef.current.onQueryChange();
  };

  openSelectDeliverable(ca) {
    this.setState({ openSelectDeliverable: true, caSelected: ca });
  }

  closeSelectDeliverable() {
    this.setState({ openSelectDeliverable: false, caSelected: null });
    this.refreshTable();
  }

  handleClickMenu = (event, account) => {
    this.setState({ anchorEl: event.currentTarget, accountMenu: account });
  };

  handleCloseMenu = () => {
    this.setState({ anchorEl: null, accountMenu: null });
  };

  render() {
    //Como no se puede usar el atributo hidden tendré q poner null en icon y tooltip y deshabilitar el botón para esconder acciones si es Entregable
    let actionButtons = [
      (rowData) => ({
        icon: "local_atm",
        tooltip: rowData.type === 1 ? "" : "Add Costs",
        disabled: rowData.type === 1,
        onClick: (event, rowData) =>
          this.props.actions.openCostModel(
            rowData.deliverable,
            rowData.control_account,
            this.props.project.project
          ),
      }),
      (rowData) => ({
        icon: "playlist_add",
        tooltip: rowData.type === 2 ? "" : "Add Deliverable",
        disabled: rowData.type === 2,
        onClick: (event, rowData) => this.openSelectDeliverable(rowData),
      }),
      (rowData) => ({
        icon: "list",
        tooltip: rowData.type === 2 ? "" : "View Costs",
        onClick: (event, rowData) =>
          this.props.actions.openReviewCostModel(
            rowData.control_account,
            rowData.name
          ),
        disabled: rowData.type === 2,
      }),
      (rowData) => ({
        icon: "more_horiz",
        disabled: rowData.type === 2,
        tooltip: rowData.type === 2 ? "" : "More",
        onClick: (event, rowData) => {
          this.handleClickMenu(event, rowData);
        },
      }),
      {
        icon: "refresh",
        tooltip: "Refresh Data",
        isFreeAction: true,
        onClick: () => {
          this.tableRef.current && this.tableRef.current.onQueryChange();
        },
      },
    ];

    //Verificamos permisos
    if (
      Number(localStorage.getItem("role")) === ROLE_VIEWER ||
      this.props.project_status === STATUS_PROJECT_PUBLISHED
    ) {
      actionButtons.splice(0, 4);
    }

    return (
      <div>
        <MaterialTable
          tableRef={this.tableRef}
          onRowClick={(evt, selectedRow) => this.setState({ selectedRow })}
          options={{
            actionsColumnIndex: 7,
            paging: false,
            search: false,
            maxBodyHeight: "600px",
            rowStyle: (rowData) => ({
              backgroundColor: rowData.type === 2 ? "#eaeff7" : "#ffffff",
            }),
          }}
          title="Control Accounts Structure"
          columns={[
            {
              title: "Name",
              field: "name",
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
              },
            },
            {
              title: "Charge Account",
              field: "charge_account",
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
              },
            },
            {
              title: "Type",
              field: "type",
              lookup: { 1: "Control Account", 2: "Deliverable" },
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
              },
            },
          ]}
          parentChildData={(row, rows) => {
            if (row.type === 2) {
              return rows.find(
                (a) => a.control_account === row.control_account && a.type === 1
              );
            }
          }}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url =
                SERVER_PATH +
                "/control_accounts/ca_structure/" +
                this.props.project.project;
              fetch(url, AXIOS_CONFIG())
                .then((response) => response.json())
                .then((result) => {
                  //Formatear fechas
                  let caFormat = result.tree.map((o) => {
                    if (o.start_date && o.end_date) {
                      o.start_date = moment(o.start_date).format("YYYY-MM-DD");
                      o.end_date = moment(o.end_date).format("YYYY-MM-DD");
                    }
                    if (o.due_date) {
                      o.due_date = moment(o.due_date).format("YYYY-MM-DD");
                    }
                    return { ...o };
                  });
                  resolve({
                    data: caFormat,
                    page: 0,
                    totalCount: caFormat.length,
                  });
                })
                .catch((err) => {
                  resolve({ data: [], page: 0, totalCount: 0 });
                });
            })
          }
          actions={actionButtons}
        />

        <AskAlert
          openAlert={this.state.openDeleteAlert}
          handleCloseCancel={this.cancelDelete}
          handleCloseOk={this.deleteItem}
          dialogTitle={this.state.dialogTitle}
          dialogContent={this.state.dialogContent}
        />

        <SelectDeliverable
          open={this.state.openSelectDeliverable}
          caSelected={this.state.caSelected}
          handleClose={this.closeSelectDeliverable}
        />

        <CostModel />
        <ReviewCostModel />

        <Menu
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleCloseMenu}
        >
          <MenuItem
            disabled={
              this.state.accountMenu && this.state.accountMenu.type === 2
            }
            onClick={() => {
              this.props.showCa(this.state.accountMenu);
              this.handleCloseMenu();
            }}
          >
            <ListItemIcon>
              <VisibilityIcon />
            </ListItemIcon>
            <ListItemText
              style={{ paddingLeft: 0 }}
              inset
              primary="View information"
            />
          </MenuItem>
          <MenuItem
            disabled={
              this.state.accountMenu && this.state.accountMenu.type === 2
            }
            onClick={() => {
              this.props.editCa(this.state.accountMenu);
              this.handleCloseMenu();
            }}
          >
            <ListItemIcon>
              <EditIcon />
            </ListItemIcon>
            <ListItemText style={{ paddingLeft: 0 }} inset primary="Edit" />
          </MenuItem>
          <MenuItem
            disabled={
              this.state.accountMenu && this.state.accountMenu.type === 2
            }
            onClick={() => {
              const { accountMenu } = this.state;
              if (accountMenu.type === 1) {
                this.askDeleteCa(accountMenu.control_account);
              } else {
                this.askDeleteAssignation(accountMenu.assignation);
              }
              this.handleCloseMenu();
            }}
          >
            <ListItemIcon>
              <TrashIcon />
            </ListItemIcon>
            <ListItemText style={{ paddingLeft: 0 }} inset primary="Delete" />
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    ca: state.ca,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { withRef: true }
)(ListControlAccount);



// WEBPACK FOOTER //
// ./src/features/ca/ListControlAccount.js